// extracted by mini-css-extract-plugin
export default {"doors":"PartnerDoorsSection_doors__zhP3R","door":"PartnerDoorsSection_door__hH+3v"};